import { render, staticRenderFns } from "./TransProgramPersonWDisContent.vue?vue&type=template&id=5c7bc876&scoped=true"
import script from "./TransProgramPersonWDisContent.vue?vue&type=script&lang=ts"
export * from "./TransProgramPersonWDisContent.vue?vue&type=script&lang=ts"
import style0 from "./TransProgramPersonWDisContent.vue?vue&type=style&index=0&id=5c7bc876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7bc876",
  null
  
)

export default component.exports